@if (!error && versionText && versionText.length > 0 && !certLoad) {
  <div class="pxs-ready">
    <svg class="pxs-ready-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      <path d="M9 12l2 2 4-4"/>
    </svg>
    <span class="pxs-ready-text">{{versionText}} ({{versionNumber}})</span>
    <span class="pxs-ready-spacer"></span>
    @if (selectedSubject && selectedSubject.length > 0) {
      <span class="pxs-ready-cert">{{selectedSubject}}</span>
      <span class="pxs-ready-sep"></span>
    }
    <span class="pxs-ready-link" (click)="selectCert()">Spremeni certifikat</span>
  </div>
}

@if (error && !certLoad) {
  <div class="pxs-alert">
    <div class="pxs-alert-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        <path d="M12 8v4"/><circle cx="12" cy="16" r="0.5" fill="currentColor"/>
      </svg>
    </div>
    <div class="pxs-alert-content">
      <p class="pxs-alert-title">Podpisna komponenta ni dosegljiva</p>
      <p class="pxs-alert-text">Namizna aplikacija SETCCE proXSign ni dosegljiva na vaši napravi. Prosimo, preverite da je nameščena in aktivna.</p>
      <p class="pxs-alert-text">Vloge ni mogoče oddati brez aktivne podpisne komponente in veljavnega digitalnega potrdila.</p>
      <a class="pxs-alert-link" target="_blank" href="https://www.si-trust.gov.si/sl/podpora-uporabnikom/podpisovanje-s-komponento-proxsign">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        Namestite podpisno komponento
      </a>
    </div>
  </div>
}

@if (certLoad) {
  <div class="com-loader-wrapper">
    <div class="loader-wrapper com-loader-w">
      <span class="loader"></span>
    </div>
    <div>
      <p>Poteka povezovanje podpisne komponente na vaši napravi ...</p>
    </div>
  </div>
}